var $2872659e6c428111$exports = {};
$2872659e6c428111$exports = {
    "dismiss": `Hylk\xe4\xe4`
};


export {$2872659e6c428111$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
